// Authenticated fetch wrapper. Pulls the current Clerk session JWT and
// attaches it as `Authorization: Bearer <token>` so backend requireAuth()
// can verify the caller.
//
// Phase 3 migration note: the public signature (`apiFetch(input, init)`)
// is unchanged from the Supabase-Auth version. Call sites don't need to
// update.
//
// Usage:
//   const res = await apiFetch('/api/insurance/policies');
//   const data = await res.json();
//
// Behaves exactly like fetch() otherwise. If there is no active session,
// the request still goes out (without the header) and the backend will
// reject it with 401 — the calling code should handle that.

export async function apiFetch(input, init = {}) {
  let token = null;
  try {
    // `window.Clerk` is the global the @clerk/clerk-react SDK sets after
    // mount. We read it lazily here (rather than importing a React hook)
    // so apiFetch can be called from anywhere — utilities, contexts,
    // event handlers — without being inside a component tree.
    const clerk = typeof window !== 'undefined' ? window.Clerk : null;
    if (clerk?.session) {
      token = await clerk.session.getToken();
    }
  } catch {
    // ignore — we'll send the request without a token and let the API 401
  }

  const headers = new Headers(init.headers || {});
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return fetch(input, { ...init, headers });
}
